import { render } from "./CareerDetail.vue?vue&type=template&id=d1382efa&scoped=true"
import script from "./CareerDetail.vue?vue&type=script&lang=ts"
export * from "./CareerDetail.vue?vue&type=script&lang=ts"

import "./CareerDetail.vue?vue&type=style&index=0&id=d1382efa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d1382efa"

export default script